window.SubscriptionFunnel.FunnelUtilities = {
  capitalizeDogName(name) {
    const trimmed = (name || "").trim();

    if (!trimmed) {
      return "";
    }

    return trimmed
      .split(/\s+/)
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(" ");
  },

  storeStepData(step) {
    const stepElement = document.getElementById(steps[step]);
    stepElement.querySelectorAll("[data-quiz-key]").forEach((el) => {
      const key = el.dataset.quizKey;
      if (el.type === "checkbox") {
        quizData[key] = el.checked;
      } else if (el.type === "radio") {
        if (el.checked) {
          quizData[key] = el.value;
        }
      } else {
        quizData[key] = el.value;
      }
    });
  },

  updateProgressBar(currentStep) {
    const totalSteps = steps.length;
    const progress = (currentStep / (totalSteps - 1)) * 100;
    document.getElementById("progress-bar").style.width = `${progress}%`;
    if (currentStep === 0) {
      const tracker = document.getElementById("funnel-tracker");
      if (tracker) {
        tracker.style.display = "none";
      }
    } else {
      const tracker = document.getElementById("funnel-tracker");
      if (tracker) {
        tracker.style.display = "block";
      }
      const trackerStep = document.getElementById("funnel-tracker-step");
      if (trackerStep) {
        trackerStep.textContent =
          currentStep >= totalSteps ? totalSteps - 1 : currentStep;
      }
    }
  },

  handleInputChange(event) {
    document
      .querySelectorAll(".form-input-text-error-message")
      .forEach((el) => {
        el.classList.add("display-none");
      });
    document.querySelectorAll(".card--error").forEach((el) => {
      el.classList.add("card--error");
    });

    document.querySelectorAll(".radio-decoy-component--error").forEach((el) => {
      el.classList.remove("radio-decoy-component--error");
    });

    if (event.target.type === "checkbox") {
      quizData[event.target.name] = event.target.checked;
    } else {
      quizData[event.target.name] = event.target.value;
    }

    if (event.target.name === "extraToy" && event.target.value === "true") {
      document.querySelector(".xtc-plan-text").classList.remove("display-none");
    } else {
      document.querySelector(".xtc-plan-text").classList.add("display-none");
    }

    if (event.target.name === 'kibbleFlavor') {
      if (window.SubscriptionFunnel.StepKibble) {
        SubscriptionFunnel.StepKibble.updateKibbleImageAndText(event.target.id);
      }
    }

    if (event.target.name === 'assortment') {
      if (window.SubscriptionFunnel.StepAssortment) {
        SubscriptionFunnel.StepAssortment.updateAssortmentImageAndText(event.target.id);
      }
    }

    // XTC - Control
    if (
      event.target.name === "commitmentLength" &&
      (event.target.id === "1_month" ||
        event.target.id === "6_month" ||
        event.target.id === "12_month")
    ) {
      SubscriptionFunnel.StepPlanSelection.handlePlanSelectionClick(event);
      SubscriptionFunnel.StepExtraToy.applyPlanClickXtcUpdates(event);
    }

    // XTC - Variants v7
    if (
      event?.target?.id?.toLowerCase()?.includes("monthly_v7") ||
      event?.target?.id?.toLowerCase()?.includes("prepaid_v7")
    ) {
      SubscriptionFunnel.StepPlanSelection.handlePlanSelectionClick(event);
      SubscriptionFunnel.StepExtraToy.applyPlanClickXtcUpdates(event);
    }
  },

  validateRequiredRadioField(optionName) {
    if (
      optionName === "extraToy" &&
      (SubscriptionFunnel.FunnelUtilities.promo_type === "FEXT" ||
       SubscriptionFunnel.FunnelUtilities.promo_type === "FEXC")
    ) {
      SubscriptionFunnel.FunnelNavigation.nextStep();
      return true;
    }

    const selected = document.querySelector(
      `input[name="${optionName}"]:checked`
    );

    if (!selected) {
      // Generic handling for step-based radio validation (kibble, assortment, etc.)
      const stepMappings = {
        'kibbleFlavor': 'select-kibble',
        'assortment': 'select-assortment'
      };
      
      const stepId = stepMappings[optionName];
      if (stepId) {
        const errorMessage = document.querySelector(`#${stepId} .form-input-text-error-message`);
        if (errorMessage) {
          errorMessage.classList.remove("display-none");
        }
        
        // Add error styling to the radio button options
        const options = document.querySelectorAll(`#${stepId} .radio-decoy-component-button-wrapper`);
        options.forEach(option => {
          option.classList.add("radio-decoy-component--error");
        });
        
        return false;
      }

      document
        .querySelector(`div#${optionName}-input .radio-decoy-component`)
        ?.classList.add("radio-decoy-component--error");

      document
        .querySelector(`div#${optionName}-input .form-input-text-error-message`)
        ?.classList.remove("display-none");
      return false;
    }

    SubscriptionFunnel.FunnelNavigation.nextStep();
  },

  clearErrors(requiredId) {
    document
      .getElementById(requiredId)
      .classList.remove("text-input-component-input--error");
    document
      .querySelector(
        `div.text-input-component:has(#${requiredId}) div .form-input-text-error-message`
      )
      .classList.add("display-none");
  },

  resetFunnel() {
    const upsellSuccessModalOverlay = document.querySelector(
      "#sold-out .modal-overlay"
    );
    upsellSuccessModalOverlay.style["opacity"] = "0";
    upsellSuccessModalOverlay.style["visibility"] = "hidden ";

    this.updateProgressBar(0);
    handleNavRudderstack(titleMapping[0]);
    document.getElementById(steps[currentStepIdx]).classList.remove("active");
    document
      .getElementById(steps[currentStepIdx] + "-header")
      .classList.remove("active");

    document.getElementById(steps[0]).classList.add("active");
    document.getElementById(steps[0] + "-header").classList.add("active");

    currentStepIdx = 0;

    Shopify.analytics.publish("rudderstack_track", {
      eventName: "Growth Funnel Sold Out Selection",
      eventData: {
        selection: "Reset",
      }
    });
  },

  handleFirstTab(e) {
    if (e.keyCode === 9) {
      document.body.classList.add("keyboard-user");
      window.removeEventListener("keydown", this.handleFirstTab);
    }
  },

  trackNonFunctionalElClick(nonFunctionalElName) {
    Shopify.analytics.publish("rudderstack_track", {
      eventName: "Non Functional Element Clicked",
      eventData: {
        nonFunctionalElement: nonFunctionalElName,
      }
    });
  },

  getPredictedLtv(
    productType,
    paymentType,
    extraToyClub,
    isLicense,
    isGWP,
    commitmentLength
  ) {
    const data = [
      {
        productType: "BARKBOX",
        paymentType: "Prepaid",
        extraToyClub: true,
        isLicense: false,
        isGWP: true,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 194.4,
        predicted_value_rate_at_first_purchase: 47.37,
      },

      {
        productType: "BARKBOX",
        paymentType: "Prepaid",
        extraToyClub: true,
        isLicense: false,
        isGWP: true,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 356.4,
        predicted_value_rate_at_first_purchase: 86.84,
      },

      {
        productType: "BARKBOX",
        paymentType: "Prepaid",
        extraToyClub: true,
        isLicense: false,
        isGWP: false,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 194.4,
        predicted_value_rate_at_first_purchase: 47.37,
      },

      {
        productType: "BARKBOX",
        paymentType: "Prepaid",
        extraToyClub: true,
        isLicense: false,
        isGWP: false,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 356.4,
        predicted_value_rate_at_first_purchase: 86.84,
      },

      {
        productType: "BARKBOX",
        paymentType: "Prepaid",
        extraToyClub: true,
        isLicense: true,
        isGWP: true,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 194.4,
        predicted_value_rate_at_first_purchase: 47.37,
      },

      {
        productType: "BARKBOX",
        paymentType: "Prepaid",
        extraToyClub: true,
        isLicense: true,
        isGWP: true,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 356.4,
        predicted_value_rate_at_first_purchase: 86.84,
      },

      {
        productType: "BARKBOX",
        paymentType: "Prepaid",
        extraToyClub: true,
        isLicense: true,
        isGWP: false,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 194.4,
        predicted_value_rate_at_first_purchase: 47.37,
      },

      {
        productType: "BARKBOX",
        paymentType: "Prepaid",
        extraToyClub: true,
        isLicense: true,
        isGWP: false,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 356.4,
        predicted_value_rate_at_first_purchase: 86.84,
      },

      {
        productType: "BARKBOX",
        paymentType: "Prepaid",
        extraToyClub: true,
        isLicense: false,
        isGWP: true,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 194.4,
        predicted_value_rate_at_first_purchase: 47.37,
      },

      {
        productType: "BARKBOX",
        paymentType: "Prepaid",
        extraToyClub: true,
        isLicense: false,
        isGWP: true,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 356.4,
        predicted_value_rate_at_first_purchase: 86.84,
      },

      {
        productType: "BARKBOX",
        paymentType: "Prepaid",
        extraToyClub: true,
        isLicense: false,
        isGWP: false,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 194.4,
        predicted_value_rate_at_first_purchase: 47.37,
      },

      {
        productType: "BARKBOX",
        paymentType: "Prepaid",
        extraToyClub: true,
        isLicense: false,
        isGWP: false,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 356.4,
        predicted_value_rate_at_first_purchase: 86.84,
      },

      {
        productType: "BARKBOX",
        paymentType: "Prepaid",
        extraToyClub: false,
        isLicense: false,
        isGWP: true,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 145.8,
        predicted_value_rate_at_first_purchase: 35.53,
      },

      {
        productType: "BARKBOX",
        paymentType: "Prepaid",
        extraToyClub: false,
        isLicense: false,
        isGWP: true,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 259.2,
        predicted_value_rate_at_first_purchase: 63.16,
      },

      {
        productType: "BARKBOX",
        paymentType: "Prepaid",
        extraToyClub: false,
        isLicense: false,
        isGWP: false,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 145.8,
        predicted_value_rate_at_first_purchase: 35.53,
      },

      {
        productType: "BARKBOX",
        paymentType: "Prepaid",
        extraToyClub: false,
        isLicense: false,
        isGWP: false,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 259.2,
        predicted_value_rate_at_first_purchase: 63.16,
      },

      {
        productType: "BARKBOX",
        paymentType: "Prepaid",
        extraToyClub: false,
        isLicense: true,
        isGWP: true,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 145.8,
        predicted_value_rate_at_first_purchase: 35.53,
      },

      {
        productType: "BARKBOX",
        paymentType: "Prepaid",
        extraToyClub: false,
        isLicense: true,
        isGWP: true,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 259.2,
        predicted_value_rate_at_first_purchase: 63.16,
      },

      {
        productType: "BARKBOX",
        paymentType: "Prepaid",
        extraToyClub: false,
        isLicense: true,
        isGWP: false,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 145.8,
        predicted_value_rate_at_first_purchase: 35.53,
      },

      {
        productType: "BARKBOX",
        paymentType: "Prepaid",
        extraToyClub: false,
        isLicense: true,
        isGWP: false,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 259.2,
        predicted_value_rate_at_first_purchase: 63.16,
      },

      {
        productType: "BARKBOX",
        paymentType: "Prepaid",
        extraToyClub: false,
        isLicense: false,
        isGWP: true,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 145.8,
        predicted_value_rate_at_first_purchase: 35.53,
      },

      {
        productType: "BARKBOX",
        paymentType: "Prepaid",
        extraToyClub: false,
        isLicense: false,
        isGWP: true,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 259.2,
        predicted_value_rate_at_first_purchase: 63.16,
      },

      {
        productType: "BARKBOX",
        paymentType: "Prepaid",
        extraToyClub: false,
        isLicense: false,
        isGWP: false,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 145.8,
        predicted_value_rate_at_first_purchase: 35.53,
      },

      {
        productType: "BARKBOX",
        paymentType: "Prepaid",
        extraToyClub: false,
        isLicense: false,
        isGWP: false,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 259.2,
        predicted_value_rate_at_first_purchase: 63.16,
      },

      {
        productType: "BARKBOX",
        paymentType: "Monthly",
        extraToyClub: true,
        isLicense: false,
        isGWP: true,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 176.4,
        predicted_value_rate_at_first_purchase: 42.98,
      },

      {
        productType: "BARKBOX",
        paymentType: "Monthly",
        extraToyClub: true,
        isLicense: false,
        isGWP: true,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 207.9,
        predicted_value_rate_at_first_purchase: 50.66,
      },

      {
        productType: "BARKBOX",
        paymentType: "Monthly",
        extraToyClub: true,
        isLicense: false,
        isGWP: false,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 252.0,
        predicted_value_rate_at_first_purchase: 61.4,
      },

      {
        productType: "BARKBOX",
        paymentType: "Monthly",
        extraToyClub: true,
        isLicense: false,
        isGWP: false,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 297.0,
        predicted_value_rate_at_first_purchase: 72.37,
      },

      {
        productType: "BARKBOX",
        paymentType: "Monthly",
        extraToyClub: true,
        isLicense: false,
        isGWP: false,
        commitmentLength: 1,
        predicted_value_at_first_purchase: 132.0,
        predicted_value_rate_at_first_purchase: 32.16,
      },

      {
        productType: "BARKBOX",
        paymentType: "Monthly",
        extraToyClub: true,
        isLicense: true,
        isGWP: true,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 141.12,
        predicted_value_rate_at_first_purchase: 34.39,
      },

      {
        productType: "BARKBOX",
        paymentType: "Monthly",
        extraToyClub: true,
        isLicense: true,
        isGWP: true,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 166.32,
        predicted_value_rate_at_first_purchase: 40.53,
      },

      {
        productType: "BARKBOX",
        paymentType: "Monthly",
        extraToyClub: true,
        isLicense: true,
        isGWP: false,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 201.6,
        predicted_value_rate_at_first_purchase: 49.12,
      },

      {
        productType: "BARKBOX",
        paymentType: "Monthly",
        extraToyClub: true,
        isLicense: true,
        isGWP: false,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 237.6,
        predicted_value_rate_at_first_purchase: 57.89,
      },

      {
        productType: "BARKBOX",
        paymentType: "Monthly",
        extraToyClub: true,
        isLicense: false,
        isGWP: true,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 176.4,
        predicted_value_rate_at_first_purchase: 42.98,
      },

      {
        productType: "BARKBOX",
        paymentType: "Monthly",
        extraToyClub: true,
        isLicense: false,
        isGWP: true,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 207.9,
        predicted_value_rate_at_first_purchase: 50.66,
      },

      {
        productType: "BARKBOX",
        paymentType: "Monthly",
        extraToyClub: true,
        isLicense: false,
        isGWP: false,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 252.0,
        predicted_value_rate_at_first_purchase: 61.4,
      },

      {
        productType: "BARKBOX",
        paymentType: "Monthly",
        extraToyClub: true,
        isLicense: false,
        isGWP: false,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 297.0,
        predicted_value_rate_at_first_purchase: 72.37,
      },

      {
        productType: "BARKBOX",
        paymentType: "Monthly",
        extraToyClub: true,
        isLicense: false,
        isGWP: false,
        commitmentLength: 1,
        predicted_value_at_first_purchase: 132.0,
        predicted_value_rate_at_first_purchase: 32.16,
      },

      {
        productType: "BARKBOX",
        paymentType: "Monthly",
        extraToyClub: false,
        isLicense: false,
        isGWP: true,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 132.3,
        predicted_value_rate_at_first_purchase: 32.24,
      },

      {
        productType: "BARKBOX",
        paymentType: "Monthly",
        extraToyClub: false,
        isLicense: false,
        isGWP: true,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 151.2,
        predicted_value_rate_at_first_purchase: 36.84,
      },

      {
        productType: "BARKBOX",
        paymentType: "Monthly",
        extraToyClub: false,
        isLicense: false,
        isGWP: false,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 189.0,
        predicted_value_rate_at_first_purchase: 46.05,
      },

      {
        productType: "BARKBOX",
        paymentType: "Monthly",
        extraToyClub: false,
        isLicense: false,
        isGWP: false,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 216.0,
        predicted_value_rate_at_first_purchase: 52.63,
      },

      {
        productType: "BARKBOX",
        paymentType: "Monthly",
        extraToyClub: false,
        isLicense: false,
        isGWP: false,
        commitmentLength: 1,
        predicted_value_at_first_purchase: 105.0,
        predicted_value_rate_at_first_purchase: 25.58,
      },

      {
        productType: "BARKBOX",
        paymentType: "Monthly",
        extraToyClub: false,
        isLicense: true,
        isGWP: true,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 105.84,
        predicted_value_rate_at_first_purchase: 25.79,
      },

      {
        productType: "BARKBOX",
        paymentType: "Monthly",
        extraToyClub: false,
        isLicense: true,
        isGWP: true,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 120.96,
        predicted_value_rate_at_first_purchase: 29.47,
      },

      {
        productType: "BARKBOX",
        paymentType: "Monthly",
        extraToyClub: false,
        isLicense: true,
        isGWP: false,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 151.2,
        predicted_value_rate_at_first_purchase: 36.84,
      },

      {
        productType: "BARKBOX",
        paymentType: "Monthly",
        extraToyClub: false,
        isLicense: true,
        isGWP: false,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 172.8,
        predicted_value_rate_at_first_purchase: 42.11,
      },

      {
        productType: "BARKBOX",
        paymentType: "Monthly",
        extraToyClub: false,
        isLicense: false,
        isGWP: true,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 132.3,
        predicted_value_rate_at_first_purchase: 32.24,
      },

      {
        productType: "BARKBOX",
        paymentType: "Monthly",
        extraToyClub: false,
        isLicense: false,
        isGWP: true,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 151.2,
        predicted_value_rate_at_first_purchase: 36.84,
      },

      {
        productType: "BARKBOX",
        paymentType: "Monthly",
        extraToyClub: false,
        isLicense: false,
        isGWP: false,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 189.0,
        predicted_value_rate_at_first_purchase: 46.05,
      },

      {
        productType: "BARKBOX",
        paymentType: "Monthly",
        extraToyClub: false,
        isLicense: false,
        isGWP: false,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 216.0,
        predicted_value_rate_at_first_purchase: 52.63,
      },

      {
        productType: "BARKBOX",
        paymentType: "Monthly",
        extraToyClub: false,
        isLicense: false,
        isGWP: false,
        commitmentLength: 1,
        predicted_value_at_first_purchase: 105.0,
        predicted_value_rate_at_first_purchase: 25.58,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Prepaid",
        extraToyClub: true,
        isLicense: false,
        isGWP: true,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 237.6,
        predicted_value_rate_at_first_purchase: 57.89,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Prepaid",
        extraToyClub: true,
        isLicense: false,
        isGWP: true,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 410.4,
        predicted_value_rate_at_first_purchase: 100.0,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Prepaid",
        extraToyClub: true,
        isLicense: false,
        isGWP: false,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 237.6,
        predicted_value_rate_at_first_purchase: 57.89,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Prepaid",
        extraToyClub: true,
        isLicense: false,
        isGWP: false,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 410.4,
        predicted_value_rate_at_first_purchase: 100.0,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Prepaid",
        extraToyClub: true,
        isLicense: true,
        isGWP: true,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 237.6,
        predicted_value_rate_at_first_purchase: 57.89,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Prepaid",
        extraToyClub: true,
        isLicense: true,
        isGWP: true,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 410.4,
        predicted_value_rate_at_first_purchase: 100.0,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Prepaid",
        extraToyClub: true,
        isLicense: true,
        isGWP: false,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 237.6,
        predicted_value_rate_at_first_purchase: 57.89,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Prepaid",
        extraToyClub: true,
        isLicense: true,
        isGWP: false,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 410.4,
        predicted_value_rate_at_first_purchase: 100.0,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Prepaid",
        extraToyClub: true,
        isLicense: false,
        isGWP: true,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 237.6,
        predicted_value_rate_at_first_purchase: 57.89,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Prepaid",
        extraToyClub: true,
        isLicense: false,
        isGWP: true,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 410.4,
        predicted_value_rate_at_first_purchase: 100.0,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Prepaid",
        extraToyClub: true,
        isLicense: false,
        isGWP: false,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 237.6,
        predicted_value_rate_at_first_purchase: 57.89,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Prepaid",
        extraToyClub: true,
        isLicense: false,
        isGWP: false,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 410.4,
        predicted_value_rate_at_first_purchase: 100.0,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Prepaid",
        extraToyClub: false,
        isLicense: false,
        isGWP: true,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 189.0,
        predicted_value_rate_at_first_purchase: 46.05,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Prepaid",
        extraToyClub: false,
        isLicense: false,
        isGWP: true,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 313.2,
        predicted_value_rate_at_first_purchase: 76.32,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Prepaid",
        extraToyClub: false,
        isLicense: false,
        isGWP: false,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 189.0,
        predicted_value_rate_at_first_purchase: 46.05,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Prepaid",
        extraToyClub: false,
        isLicense: false,
        isGWP: false,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 313.2,
        predicted_value_rate_at_first_purchase: 76.32,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Prepaid",
        extraToyClub: false,
        isLicense: true,
        isGWP: true,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 189.0,
        predicted_value_rate_at_first_purchase: 46.05,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Prepaid",
        extraToyClub: false,
        isLicense: true,
        isGWP: true,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 313.2,
        predicted_value_rate_at_first_purchase: 76.32,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Prepaid",
        extraToyClub: false,
        isLicense: true,
        isGWP: false,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 189.0,
        predicted_value_rate_at_first_purchase: 46.05,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Prepaid",
        extraToyClub: false,
        isLicense: true,
        isGWP: false,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 313.2,
        predicted_value_rate_at_first_purchase: 76.32,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Prepaid",
        extraToyClub: false,
        isLicense: false,
        isGWP: true,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 189.0,
        predicted_value_rate_at_first_purchase: 46.05,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Prepaid",
        extraToyClub: false,
        isLicense: false,
        isGWP: true,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 313.2,
        predicted_value_rate_at_first_purchase: 76.32,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Prepaid",
        extraToyClub: false,
        isLicense: false,
        isGWP: false,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 189.0,
        predicted_value_rate_at_first_purchase: 46.05,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Prepaid",
        extraToyClub: false,
        isLicense: false,
        isGWP: false,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 313.2,
        predicted_value_rate_at_first_purchase: 76.32,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Monthly",
        extraToyClub: true,
        isLicense: false,
        isGWP: true,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 215.6,
        predicted_value_rate_at_first_purchase: 52.53,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Monthly",
        extraToyClub: true,
        isLicense: false,
        isGWP: true,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 239.4,
        predicted_value_rate_at_first_purchase: 58.33,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Monthly",
        extraToyClub: true,
        isLicense: false,
        isGWP: false,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 308.0,
        predicted_value_rate_at_first_purchase: 75.05,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Monthly",
        extraToyClub: true,
        isLicense: false,
        isGWP: false,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 342.0,
        predicted_value_rate_at_first_purchase: 83.33,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Monthly",
        extraToyClub: true,
        isLicense: false,
        isGWP: false,
        commitmentLength: 1,
        predicted_value_at_first_purchase: 162.0,
        predicted_value_rate_at_first_purchase: 39.47,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Monthly",
        extraToyClub: true,
        isLicense: true,
        isGWP: true,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 172.48,
        predicted_value_rate_at_first_purchase: 42.03,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Monthly",
        extraToyClub: true,
        isLicense: true,
        isGWP: true,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 191.52,
        predicted_value_rate_at_first_purchase: 46.67,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Monthly",
        extraToyClub: true,
        isLicense: true,
        isGWP: false,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 246.4,
        predicted_value_rate_at_first_purchase: 60.04,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Monthly",
        extraToyClub: true,
        isLicense: true,
        isGWP: false,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 273.6,
        predicted_value_rate_at_first_purchase: 66.67,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Monthly",
        extraToyClub: true,
        isLicense: false,
        isGWP: true,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 215.6,
        predicted_value_rate_at_first_purchase: 52.53,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Monthly",
        extraToyClub: true,
        isLicense: false,
        isGWP: true,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 239.4,
        predicted_value_rate_at_first_purchase: 58.33,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Monthly",
        extraToyClub: true,
        isLicense: false,
        isGWP: false,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 308.0,
        predicted_value_rate_at_first_purchase: 75.05,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Monthly",
        extraToyClub: true,
        isLicense: false,
        isGWP: false,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 342.0,
        predicted_value_rate_at_first_purchase: 83.33,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Monthly",
        extraToyClub: true,
        isLicense: false,
        isGWP: false,
        commitmentLength: 1,
        predicted_value_at_first_purchase: 162.0,
        predicted_value_rate_at_first_purchase: 39.47,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Monthly",
        extraToyClub: false,
        isLicense: false,
        isGWP: true,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 171.5,
        predicted_value_rate_at_first_purchase: 41.79,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Monthly",
        extraToyClub: false,
        isLicense: false,
        isGWP: true,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 182.7,
        predicted_value_rate_at_first_purchase: 44.52,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Monthly",
        extraToyClub: false,
        isLicense: false,
        isGWP: false,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 245.0,
        predicted_value_rate_at_first_purchase: 59.7,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Monthly",
        extraToyClub: false,
        isLicense: false,
        isGWP: false,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 261.0,
        predicted_value_rate_at_first_purchase: 63.6,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Monthly",
        extraToyClub: false,
        isLicense: false,
        isGWP: false,
        commitmentLength: 1,
        predicted_value_at_first_purchase: 135.0,
        predicted_value_rate_at_first_purchase: 32.89,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Monthly",
        extraToyClub: false,
        isLicense: true,
        isGWP: true,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 137.2,
        predicted_value_rate_at_first_purchase: 33.43,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Monthly",
        extraToyClub: false,
        isLicense: true,
        isGWP: true,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 146.16,
        predicted_value_rate_at_first_purchase: 35.61,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Monthly",
        extraToyClub: false,
        isLicense: true,
        isGWP: false,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 196.0,
        predicted_value_rate_at_first_purchase: 47.76,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Monthly",
        extraToyClub: false,
        isLicense: true,
        isGWP: false,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 208.8,
        predicted_value_rate_at_first_purchase: 50.88,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Monthly",
        extraToyClub: false,
        isLicense: false,
        isGWP: true,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 171.5,
        predicted_value_rate_at_first_purchase: 41.79,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Monthly",
        extraToyClub: false,
        isLicense: false,
        isGWP: true,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 182.7,
        predicted_value_rate_at_first_purchase: 44.52,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Monthly",
        extraToyClub: false,
        isLicense: false,
        isGWP: false,
        commitmentLength: 6,
        predicted_value_at_first_purchase: 245.0,
        predicted_value_rate_at_first_purchase: 59.7,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Monthly",
        extraToyClub: false,
        isLicense: false,
        isGWP: false,
        commitmentLength: 12,
        predicted_value_at_first_purchase: 261.0,
        predicted_value_rate_at_first_purchase: 63.6,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Monthly",
        extraToyClub: false,
        isLicense: false,
        isGWP: false,
        commitmentLength: 1,
        predicted_value_at_first_purchase: 135.0,
        predicted_value_rate_at_first_purchase: 32.89,
      },

      {
        productType: "BARKBOX",
        paymentType: "Prepaid",
        extraToyClub: true,
        isLicense: false,
        isGWP: true,
        commitmentLength: 3,
        predicted_value_at_first_purchase: 113.4,
        predicted_value_rate_at_first_purchase: 27.63,
      },

      {
        productType: "BARKBOX",
        paymentType: "Prepaid",
        extraToyClub: true,
        isLicense: false,
        isGWP: false,
        commitmentLength: 3,
        predicted_value_at_first_purchase: 113.4,
        predicted_value_rate_at_first_purchase: 27.63,
      },

      {
        productType: "BARKBOX",
        paymentType: "Prepaid",
        extraToyClub: true,
        isLicense: true,
        isGWP: true,
        commitmentLength: 3,
        predicted_value_at_first_purchase: 113.4,
        predicted_value_rate_at_first_purchase: 27.63,
      },

      {
        productType: "BARKBOX",
        paymentType: "Prepaid",
        extraToyClub: true,
        isLicense: true,
        isGWP: false,
        commitmentLength: 3,
        predicted_value_at_first_purchase: 113.4,
        predicted_value_rate_at_first_purchase: 27.63,
      },

      {
        productType: "BARKBOX",
        paymentType: "Prepaid",
        extraToyClub: true,
        isLicense: false,
        isGWP: true,
        commitmentLength: 3,
        predicted_value_at_first_purchase: 113.4,
        predicted_value_rate_at_first_purchase: 27.63,
      },

      {
        productType: "BARKBOX",
        paymentType: "Prepaid",
        extraToyClub: true,
        isLicense: false,
        isGWP: false,
        commitmentLength: 3,
        predicted_value_at_first_purchase: 113.4,
        predicted_value_rate_at_first_purchase: 27.63,
      },

      {
        productType: "BARKBOX",
        paymentType: "Prepaid",
        extraToyClub: false,
        isLicense: false,
        isGWP: true,
        commitmentLength: 3,
        predicted_value_at_first_purchase: 89.1,
        predicted_value_rate_at_first_purchase: 21.71,
      },

      {
        productType: "BARKBOX",
        paymentType: "Prepaid",
        extraToyClub: false,
        isLicense: false,
        isGWP: false,
        commitmentLength: 3,
        predicted_value_at_first_purchase: 89.1,
        predicted_value_rate_at_first_purchase: 21.71,
      },

      {
        productType: "BARKBOX",
        paymentType: "Prepaid",
        extraToyClub: false,
        isLicense: true,
        isGWP: true,
        commitmentLength: 3,
        predicted_value_at_first_purchase: 89.1,
        predicted_value_rate_at_first_purchase: 21.71,
      },

      {
        productType: "BARKBOX",
        paymentType: "Prepaid",
        extraToyClub: false,
        isLicense: true,
        isGWP: false,
        commitmentLength: 3,
        predicted_value_at_first_purchase: 89.1,
        predicted_value_rate_at_first_purchase: 21.71,
      },

      {
        productType: "BARKBOX",
        paymentType: "Prepaid",
        extraToyClub: false,
        isLicense: false,
        isGWP: true,
        commitmentLength: 3,
        predicted_value_at_first_purchase: 89.1,
        predicted_value_rate_at_first_purchase: 21.71,
      },

      {
        productType: "BARKBOX",
        paymentType: "Prepaid",
        extraToyClub: false,
        isLicense: false,
        isGWP: false,
        commitmentLength: 3,
        predicted_value_at_first_purchase: 89.1,
        predicted_value_rate_at_first_purchase: 21.71,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Monthly",
        extraToyClub: true,
        isLicense: false,
        isGWP: true,
        commitmentLength: 3,
        predicted_value_at_first_purchase: 109.2,
        predicted_value_rate_at_first_purchase: 26.61,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Monthly",
        extraToyClub: true,
        isLicense: false,
        isGWP: false,
        commitmentLength: 3,
        predicted_value_at_first_purchase: 156.0,
        predicted_value_rate_at_first_purchase: 38.01,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Monthly",
        extraToyClub: true,
        isLicense: true,
        isGWP: true,
        commitmentLength: 3,
        predicted_value_at_first_purchase: 87.36,
        predicted_value_rate_at_first_purchase: 21.29,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Monthly",
        extraToyClub: true,
        isLicense: true,
        isGWP: false,
        commitmentLength: 3,
        predicted_value_at_first_purchase: 124.8,
        predicted_value_rate_at_first_purchase: 30.41,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Monthly",
        extraToyClub: true,
        isLicense: false,
        isGWP: true,
        commitmentLength: 3,
        predicted_value_at_first_purchase: 109.2,
        predicted_value_rate_at_first_purchase: 26.61,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Monthly",
        extraToyClub: true,
        isLicense: false,
        isGWP: false,
        commitmentLength: 3,
        predicted_value_at_first_purchase: 156.0,
        predicted_value_rate_at_first_purchase: 38.01,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Monthly",
        extraToyClub: false,
        isLicense: false,
        isGWP: true,
        commitmentLength: 3,
        predicted_value_at_first_purchase: 90.3,
        predicted_value_rate_at_first_purchase: 22.0,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Monthly",
        extraToyClub: false,
        isLicense: false,
        isGWP: false,
        commitmentLength: 3,
        predicted_value_at_first_purchase: 129.0,
        predicted_value_rate_at_first_purchase: 31.43,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Monthly",
        extraToyClub: false,
        isLicense: true,
        isGWP: true,
        commitmentLength: 3,
        predicted_value_at_first_purchase: 72.24,
        predicted_value_rate_at_first_purchase: 17.6,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Monthly",
        extraToyClub: false,
        isLicense: true,
        isGWP: false,
        commitmentLength: 3,
        predicted_value_at_first_purchase: 103.2,
        predicted_value_rate_at_first_purchase: 25.15,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Monthly",
        extraToyClub: false,
        isLicense: false,
        isGWP: true,
        commitmentLength: 3,
        predicted_value_at_first_purchase: 90.3,
        predicted_value_rate_at_first_purchase: 22.0,
      },

      {
        productType: "SUPERCHEWER",
        paymentType: "Monthly",
        extraToyClub: false,
        isLicense: false,
        isGWP: false,
        commitmentLength: 3,
        predicted_value_at_first_purchase: 129.0,
        predicted_value_rate_at_first_purchase: 31.43,
      },
    ];

    const matchingRow = data.find(
      (row) =>
        row.productType === productType &&
        row.paymentType === paymentType &&
        row.extraToyClub === extraToyClub &&
        row.isLicense === isLicense &&
        row.isGWP === isGWP &&
        row.commitmentLength === commitmentLength
    );

    return matchingRow
      ? {
          predicted_value_at_first_purchase:
            matchingRow.predicted_value_at_first_purchase,
          predicted_value_rate_at_first_purchase:
            matchingRow.predicted_value_rate_at_first_purchase,
        }
      : null;
  },
};
